import React from 'react';
 import { makeStyles } from '@mui/styles';
import {  Link} from 'react-router-dom'

import SwipeableDrawer from '@mui/material/SwipeableDrawer';
//import Button from '@mui/material/Button';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';

import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import LoyaltyOutlinedIcon from '@mui/icons-material/LoyaltyOutlined';

import NotificationImportantOutlinedIcon from '@mui/icons-material/NotificationImportantOutlined';
import GavelOutlinedIcon from '@mui/icons-material/GavelOutlined';
import PolicyOutlinedIcon from '@mui/icons-material/PolicyOutlined';
import LocalCafeOutlinedIcon from '@mui/icons-material/LocalCafeOutlined';
import HttpsOutlinedIcon from '@mui/icons-material/HttpsOutlined';

import SettingsBackupRestoreIcon from '@mui/icons-material/SettingsBackupRestore';

// import InboxIcon from '@mui/icons-material/MoveToInbox';
// import MailIcon from '@mui/icons-material/Mail';
import ContactMailOutlinedIcon from '@mui/icons-material/ContactMailOutlined';

import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';

import EditNoteIcon from '@mui/icons-material/EditNote';
import ListAltIcon from '@mui/icons-material/ListAlt';
import TuneIcon from '@mui/icons-material/Tune';
import GTranslateIcon from '@mui/icons-material/GTranslate';
import PaletteIcon from '@mui/icons-material/Palette';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import TelegramIcon from '@mui/icons-material/Telegram';


const useStyles = makeStyles({
  list: {
    width: 250,
  },
  fullList: {
    width: 'auto',
  },
});

  //https://stackoverflow.com/questions/60522401/speeddialaction-with-react-router-dom-link
  const withLink = (to, children) => <Link to={to}>{children}</Link>;


const editresearchactions = [
  { url:"/editresearch",icon: withLink("/editresearch",<EditNoteIcon  style={{ marginTop:8 }} />), name: 'edit research' },
   { url:"/editresearchsettings",icon: withLink("/editresearchsettings",<ListAltIcon   style={{ marginTop:8 }}  />), name: 'reseatch settings' },  
  { url:"/editresearchlookandfeel",icon: withLink("/editresearchlookandfeel",<PaletteIcon  style={{ marginTop:8 }}  />), name: 'look and feel' }, 
  { url:"/editresearchtranslations",icon: withLink("/editresearchtranslations",<GTranslateIcon  style={{ marginTop:8 }}  />), name: 'translations' },
  { url:"/editresearchskiplogic",icon: withLink("/editresearchskiplogic",<AccountTreeIcon style={{ marginTop:8 }}  />), name: 'skip logic' }, 
  { url:"/editresearchdistributions",icon: withLink("/editresearchdistributions",<TuneIcon style={{ marginTop:8 }}  />), name: 'rates and distributions' }, 
  // { url:"/editresearchdistributions",icon: withLink("/editresearchdistributions",<TelegramIcon style={{ marginTop:8 }}  />), name: 'Distributions' }, 

  //   { icon: withLink("/editresearch",<PrintIcon />), name: 'Print' },
      // { icon: withLink("/editresearch",<FileCopyIcon  style={{ marginTop:8 }}  />), name: 'Copy' },
      // { icon: withLink("/editresearch",<ShareIcon  style={{ marginTop:8 }}  />), name: 'Share' }, 
  //    { icon: withLink("/editresearch",<SaveIcon />), name: 'Save' },  
];

export default function SwipeableTemporaryDrawer() {
  const classes = useStyles();
  const [state, setState] = React.useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });

  const toggleDrawer = (side, open) => event => {
    if (event && event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }

    setState({ ...state, [side]: open });
  };

  const sideList = side => (
    <div
      className={classes.list}
      role="presentation"
      onClick={toggleDrawer(side, false)}
      onKeyDown={toggleDrawer(side, false)}
    >



 
  
 

      
      <List>

      {['home'].map((text, index) => (
          <ListItem  key={text} component="a"  href='https://portal.activeresearch.com'>
             <ListItemIcon><HomeOutlinedIcon /> 
             </ListItemIcon>  
            <ListItemText primary={'home'} />
          </ListItem>
        ))}
        {[ 'myprojects'].map((text, index) => (
          <ListItem button key={text} component={Link}    to= { (text ==='home') ? '/': "/" +text}>
             <ListItemIcon>{index % 2 === 1 ? <HomeOutlinedIcon /> : <ListAltIcon />}</ListItemIcon>  
            <ListItemText primary={text} />
          </ListItem>
        ))}
      </List>
     
      <Divider /> 



<List>
{ window.location.pathname.includes('/editresearch') &&  editresearchactions.filter(function(elm) {
            //  console.log('elm.url = ' + elm.url)
            //  console.log('URLpath(URLpathName) = ' + window.location.pathname)
           if(elm.url === window.location.pathname){          
            return false;// skip the current URL icon
           } 
           return true; 
          }).map((action) => ( 
            <ListItem button key={action.name} component={Link}    to= {action.url}>

              <ListItemIcon  tooltiptitle={action.name}>{action.icon}  </ListItemIcon>
              <ListItemText primary={action.name} />
             </ListItem> 
     ))}

</List>
{/* {window.location.pathname.includes('/editresearch') ? ''  :<Divider />   } */}



{/* 
<List>
{['myprojects','editresearch', 'cookie-policy','privacy-policy','terms-of-service','refund-policy', 'contact'].map((text, index) => (
         <ListItem button key={text} component={Link}    to= { (text ==='home') ? '/': "/" +text}>
       {index % 7 === 0 ?<ListItemIcon><LocalCafeOutlinedIcon /></ListItemIcon>:''}
        {index % 7 === 1 ?<ListItemIcon><NotificationImportantOutlinedIcon /></ListItemIcon>:''}
        {index % 7 === 2 ?<ListItemIcon><PolicyOutlinedIcon /></ListItemIcon>:''}
        {index % 7 === 3 ?<ListItemIcon><HttpsOutlinedIcon /></ListItemIcon>:''}
        {index % 7 === 4 ?<ListItemIcon><GavelOutlinedIcon /></ListItemIcon>:''}
         {index % 7 === 5 ?<ListItemIcon><SettingsBackupRestoreIcon /></ListItemIcon>:''}
         {index % 7 === 6 ?<ListItemIcon><ContactMailOutlinedIcon /></ListItemIcon>:''}
         <ListItemText primary={text} />
       </ListItem>
        ))}
</List> */}


      <Divider />
      <List>
      {['home'].map((text, index) => (
          <ListItem  key={text} component="a"  href='https://www.activeresearch.com'>
             <ListItemIcon><HomeOutlinedIcon /> 
             </ListItemIcon>  
            <ListItemText primary={'corporate website'} />
          </ListItem>
        ))}
        {[ 'contact'].map((text, index) => (
         <ListItem button key={text} component={Link}    to= { (text ==='home') ? '/': "/" +text}>
      
         {index % 7 === 0 ?<ListItemIcon><ContactMailOutlinedIcon /></ListItemIcon>:''}
         <ListItemText primary={text} />
       </ListItem>
        ))}
      </List>
      {/* <List>
        {['myprojects','editresearch', 'cookie-policy','privacy-policy','terms-of-service','refund-policy', 'contact'].map((text, index) => (
         <ListItem button key={text} component={Link}    to= { (text ==='home') ? '/': "/" +text}>
       {index % 7 === 0 ?<ListItemIcon><LocalCafeOutlinedIcon /></ListItemIcon>:''}
        {index % 7 === 1 ?<ListItemIcon><NotificationImportantOutlinedIcon /></ListItemIcon>:''}
        {index % 7 === 2 ?<ListItemIcon><PolicyOutlinedIcon /></ListItemIcon>:''}
        {index % 7 === 3 ?<ListItemIcon><HttpsOutlinedIcon /></ListItemIcon>:''}
        {index % 7 === 4 ?<ListItemIcon><GavelOutlinedIcon /></ListItemIcon>:''}
         {index % 7 === 5 ?<ListItemIcon><SettingsBackupRestoreIcon /></ListItemIcon>:''}
         {index % 7 === 6 ?<ListItemIcon><ContactMailOutlinedIcon /></ListItemIcon>:''}
         <ListItemText primary={text} />
       </ListItem>
        ))}
      </List> */}
    </div>
  );

  
  return (
    <div>
            <IconButton 
            edge="start"
            className={classes.menuButton}
            color="inherit"
            aria-label="open drawer" 
            onClick={toggleDrawer('left', true)}
            >
            <MenuIcon />  
          </IconButton>
     
      <SwipeableDrawer
        open={state.left}
        onClose={toggleDrawer('left', false)}
        onOpen={toggleDrawer('left', true)}
      >
        {sideList('left')}
      </SwipeableDrawer>
    
    </div>
  );
}
